import axios from 'axios';
import AppConstants from '../config/appConstants';
import {  DATE_FORMAT } from '../containers/WorkkardDetail/constants';
import Cookies from 'js-cookie';
import {DEFAULT_TIME_FORMAT, publicApiConst} from '../common/constants';
import { ensureFreshToken, refreshAccessToken } from '../utils/tokenRefresh';
import { getAuthToken } from '../utils/authManager';
import { isLocalhostWithDevToken, getLocalhostAu, getOrgId as getOrgIdFromEnv } from '../utils/envFromCookies';
import { getAuthHeaders } from "../utils/authManager";
import { PATHS } from '../router/paths';

const GATEWAY_BASE = process.env.core_gateway_url || '';
// import * as moment from 'moment'
const moment = require("moment");
var momentTz = require("moment-timezone");

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.interceptors.request.use((request) => {
  if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      var str = "";
      for (var i in request.data) {
          if ((Object.prototype.toString.call(request.data[i]) == "[object Array]") || (Object.prototype.toString.call(request.data[i]) == "[object Object]")) {
              str += encodeURIComponent(i) + "=" + encodeURIComponent(JSON.stringify(request.data[i])) + "&";
          } else {
              str += encodeURIComponent(i) + "=" + encodeURIComponent(request.data[i]) + "&";
          }
      }
      request.data = str;
  }
  return request;
});

const REFRESH_BYPASS_PATTERNS = [
    /\/token/i,
    /\/auth/i,
];

const shouldSkipRefresh = (config) => {
    if (!config) return true;
    if (config._skipAuthRefresh) return true;
    const url = config.url || '';
    return REFRESH_BYPASS_PATTERNS.some((re) => re.test(url));
};

axios.interceptors.request.use(async (request) => {
    if (shouldSkipRefresh(request)) return request;
    try {
        await ensureFreshToken();
    } catch (e) {
    }
    if (request.headers && request.headers.Authorization) {
        const fresh = getAuthToken();
        if (fresh) request.headers.Authorization = `Bearer ${fresh}`;
    }
    return request;
});

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = (error && error.config) || {};
        const status = error && error.response && error.response.status;
        if (
            status === 401 &&
            !original._authRetried &&
            original.headers && original.headers.Authorization &&
            !shouldSkipRefresh(original) &&
            !isLocalhostWithDevToken()
        ) {
            original._authRetried = true;
            try {
                await refreshAccessToken();
                const fresh = getAuthToken();
                if (fresh) original.headers.Authorization = `Bearer ${fresh}`;
                return axios(original);
            } catch (refreshErr) {
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

export function GetGenericDate(date) {
  return date === undefined || date === null
    ? undefined
    : moment(date).toDate();
}
export function GetGenericDateFormat(date){
    if (!date) return date;
    return date.toUpperCase().includes("M/D/")?date.replace("M/D/","MM/DD/"):date
}
export function replaceDotWithUnderscore(jsonStr) {
  if (jsonStr && jsonStr.length && typeof jsonStr === "string") {
    return JSON.parse(jsonStr, function (that, k, v) {
      let newKey, newValue;
      if (k !== "key" && k.indexOf(".") > -1) {
        newKey = k.replace(".", "_");
        that[newKey] = v;
      } else if (k === "key") {
        return v.replace(".", "_");
      } else {
        return v;
      }
    });
  }

  if (jsonStr && jsonStr.constructor === Array && jsonStr.length) {
    return jsonStr.map((column) => {
      return Object.assign({}, column, {
        KeyName: column.KeyName.replace(".", "_"),
      });
    });
  }

  return jsonStr;
}

/**
 *
 * @param {Valid JSON string} jsonStr
 *  it will replace UNDERSCODE[_] with DOT[.] in deep level keys
 */
export function rplaceUnderscoreWithDot(jsonStr) {
  return JSON.parse(jsonStr, function (that, k, v) {
    let newKey, newValue;
    if (k !== "key" && k.indexOf("_") > -1) {
      newKey = k.replace("_", ".");
      that[newKey] = v;
    } else if (k === "key") {
      return v.replace("_", ".");
    } else {
      return v;
    }
  });
}

export function sortArrayByKey(inputArr, key, order = "asc") {
  inputArr.sort(function (a, b) {
    var keyVal1 = a[key].toUpperCase(); // ignore upper and lowercase
    var keyVal2 = b[key].toUpperCase(); // ignore upper and lowercase
    if (keyVal1 < keyVal2) {
      if (order == "asc") return -1;
      else return 1;
    }
    if (keyVal1 > keyVal2) {
      if (order == "asc") return 1;
      else return -1;
    }
    // names must be equal
    return 0;
  });

  return inputArr;
}

export function filterArrayByKeysValue(inputArr, key, value) {
  return inputArr.filter(function (item) {
    if (value && item[key].toLowerCase().indexOf(value.toLowerCase()) > -1)
      return true;
    else return false;
  });
}

export function isValidValue(...args) {
  for (let i = 0, length = args.length; i < length; i++) {
    var valueTobeValidated = args[i];
    if (
      isEmpty(valueTobeValidated) ||
      valueTobeValidated.toLowerCase() === "undefined" ||
      valueTobeValidated.toLowerCase() === "null" ||
      valueTobeValidated.toLowerCase() === "na" ||
      valueTobeValidated === "0" ||
      valueTobeValidated.toLowerCase() === "-"
    ) {
      return false;
    }
  }
  return true;
}

export function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (isPrototype(value)) {
    return Object.keys(value).length;
  }

  if (Array.isArray(value)) {
    return !value.length;
  }

  for (const key in value) {
    if (Object.hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

export function removeErrorOnFocus(e) {
  if (!$("#" + e.target.name + "errorBlock").is(":empty")) {
    $("#" + e.target.name + "errorBlock").text("");
  }
}

export function isPrototype(value) {
  const Ctor = value && value.constructor;
  const proto =
    (typeof Ctor == "function" && Ctor.prototype) || Object.prototype;

  return value === proto;
}

const LOCAL_MOCK_ENDPOINTS = [
  '/getactnotetemplates',
  '/getbatchactid',
  '/gadapi',
  '/fetchFilters',
  '/getnewuserinfoapi',
  '/recentsearches',
  '/activityupdate/getnotificationcounter',
  '/getnotificationcounter',
];

const LOCAL_MOCK_BASE = 'http://localhost:9002';

function shouldUseLocalMock(url) {
  if (!url) return false;
  return LOCAL_MOCK_ENDPOINTS.some((endpoint) => url.startsWith(endpoint));
}

export function httpCall(axiosConfig, rejectOnError = false) {
  if (
    process.env.NODE_ENV !== AppConstants.ENV_DEV &&
    process.env.NODE_ENV !== AppConstants.ENV_PROD
  ){
    axiosConfig.url = AppConstants.mockAPIDomain + axiosConfig.url;
  } else if (shouldUseLocalMock(axiosConfig.url)) {
    axiosConfig.url = `${LOCAL_MOCK_BASE}${axiosConfig.url}`;
  } else {
    axiosConfig.url = `${GATEWAY_BASE}${axiosConfig.url}`
  }
  let headers = getAuthHeaders()
  axiosConfig.headers = Object.assign({}, axiosConfig.headers, headers);
  axiosConfig.credentials = "include";
  return axios(axiosConfig)
    .then((response) => {
      if (response.data.Data && response.data.Data.status == 105) {
        window.location.reload();
      } else if (
        response.data.status == 403 &&
        response.data.hasOwnProperty("IsAuditUser") &&
        response.data.IsAuditUser
      ) {
        return response.data;
      } else if (response.data.status == 403) {
        window.location = PATHS.UNAUTH_LOGOUT;
      } else {
        return response.data;
      }
    })
    .catch((err) => {
      console.log(err);
      // callers that need the server's error body (eg. {status, message}) opt in here
      // instead of swallowing it, so existing callers keep their current behavior
      if (rejectOnError) {
        throw (err && err.response && err.response.data) || err;
      }
    });
}

export function httpFetch(axiosConfig) {
  if (
    process.env.NODE_ENV !== AppConstants.ENV_DEV &&
    process.env.NODE_ENV !== AppConstants.ENV_PROD
  )
    axiosConfig.url = AppConstants.mockAPIDomain + axiosConfig.url;

  if (axiosConfig.method.toLowerCase() === "post") {
    const verificationTokenInput = $('input[name="__RequestVerificationToken"]')[0];
    axiosConfig.data = Object.assign({}, axiosConfig.data, {
      __RequestVerificationToken: verificationTokenInput ? verificationTokenInput.value : "",
    });
  }
  axiosConfig.headers = Object.assign({}, axiosConfig.headers, {
    "Content-Type": "multipart/form-data",
    "cache-control": "no-cache",
    pragma: "no-cache",
  });
  var formdata = new FormData();
  for (name in axiosConfig.data) {
    formdata.append(name, axiosConfig.data[name]);
  }
  axiosConfig.data = formdata;
  return axios(axiosConfig)
    .then((response) => {
      if (response.data.status == 403) {
        window.location = PATHS.UNAUTH_LOGOUT;
      } else {
        return response.data;
      }
    })
    .catch((err) => console.log(err));
}

export function httpPostData(axiosConfig) {
  if (
    process.env.NODE_ENV !== AppConstants.ENV_DEV &&
    process.env.NODE_ENV !== AppConstants.ENV_PROD
  )
    axiosConfig.url = AppConstants.mockAPIDomain + axiosConfig.url;

  axiosConfig.data = Object.assign({}, axiosConfig.data, {
    __RequestVerificationToken:
      $('input[name="__RequestVerificationToken"]')[0].value || "",
  });
  return axios(axiosConfig)
    .then((response) => {
      if (response.data.status == 403) {
        window.location = PATHS.UNAUTH_LOGOUT;
      } else {
        return response.data;
      }
    })
    .catch((err) => console.log(err));
}

export function setObjectInStorage(key, obj) {
  localStorage.setItem(key, JSON.stringify(obj));
}

export function getObjectFromStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function decodeHtmlEntity(html) {
  if (!html) return html;

  var escapeEl = document.createElement("decodedhtmlval");
  escapeEl.innerHTML = html;
  return escapeEl.textContent;
}

export function decodeRedirectURL(obj, type, viewId) {
  if (obj) {
    switch (type) {
      case "Workkard Diary":
        return window.location.assign(
          `/ctdo?ret=view&type=workkard&referer=views&ref=${obj[0].w_id}&cno=${obj[0].w_number}&sv=${viewId}`,
        );
      case "Activity Diary":
        return window.location.assign(
          `/ctdo?ret=view&type=activity&referer=views&ref=${obj[0].a_id}&cno=${obj[0].w_number}&sv=${viewId}`,
        );
    }
  }
}

export function getUrlForLinks(viewId, value, pageNo, key) {
  var urlPrefixConstant = {
    workkardDetailPrefixUrl: "/getclmdetail?",
    activityDetailPrefixUrl: "/gad?",
    diaryDetailPrefixUrl: "/dtdo?",
  };
  if (viewId == null || viewId == "") viewId = "new";
  var url = "";
  var wkId = value["w_id"];
  var actId = value["a_id"];
  var diaryId = value["t_id"];
  var noteId = value["n_id"];
  var urlDeafultParams =
    "&sv=" +
    viewId +
    "&pn=" +
    pageNo +
    "&vwid=" +
    wkId +
    "&vaid=" +
    actId +
    "&vdid=" +
    diaryId +
    "&vnid=" +
    noteId;
  switch (key.substring(0, 1).toLowerCase()) {
    case "w":
      url = urlPrefixConstant.workkardDetailPrefixUrl + "cId=" + wkId;
      break;
    case "a":
      url = urlPrefixConstant.activityDetailPrefixUrl + "actId=" + actId;
      break;
    case "t":
      url = urlPrefixConstant.diaryDetailPrefixUrl + "id=" + diaryId;
      break;
    case "n":
      //For workkard notes activity id should be empty.
      if (checkIfValid(value["a_id"])) {
        return (
          urlPrefixConstant.activityDetailPrefixUrl +
          "actId=" +
          actId +
          urlDeafultParams +
          "&id=" +
          noteId +
          "#aun"
        );
      }
      return (
        urlPrefixConstant.workkardDetailPrefixUrl +
        "cId=" +
        wkId +
        urlDeafultParams +
        "&id=" +
        noteId +
        "#cun"
      );
  }
  url = url + urlDeafultParams;
  return url;
}

export function checkIfValid(value) {
  value = typeof value === "string" ? value.trim().toLowerCase() : value;
  return value && value !== "-" && value !== "na";
}

export function convertStrDateToMomentDateObj(strDate) {
  const arr = strDate.split("  at  ");
  const tmp2 = arr[0].split("-");
  return moment(tmp2[1] + "-" + tmp2[0] + "-" + tmp2[2] + ", " + arr[1]);
}

export function convertMomentDateToStr(date) {
  return (
    date.format("DD-MM-YYYY").toUpperCase() +
    "  at  " +
    date.format("hh:mm a").toUpperCase()
  );
}

export function compareDate(dateFirst, dateSecond, Format) {
  const firstDate = moment(dateFirst, Format);
  const secondDate = moment(dateSecond, Format);
  if (firstDate > secondDate || firstDate == secondDate) {
    return 1;
  }
  return 0;
}

export function jsonEncrypt(jsonData) {
  return btoa(JSON.stringify(jsonData));
}

export function jsonDecrypt(data) {
  try {
    return JSON.parse(atob(data));
  } catch (e) {
    return "Invalid hash";
  }
}

export function redirectURL(history, path) {
  if (deferHashWhileProfileOpen(path)) return;
  return history?.push(path);
}

export function getMenuActions(constants, params) {
  let actionArray = [];
  if (params && params.length > 0) {
    params.forEach((item) => {
      if (constants.hasOwnProperty(item)) {
        actionArray.push({
          value: constants[item].Value,
          type: constants[item].Type,
        });
      }
    });
  }
  return removeDuplicates(actionArray, "value");
}

export function removeDuplicates(actionArray, itemObj) {
  return actionArray.filter((obj, pos, arr) => {
    return arr.map((mapObj) => mapObj[itemObj]).indexOf(obj[itemObj]) === pos;
  });
}

export function reactBind(data, that) {
  return data.forEach((fn) => (that[fn] = that[fn].bind(that)));
}

export function abbreviationName(data) {
  if(data == null)
    return;
  data = data.replace(/[^a-zA-Z0-9 ]/g, "");
  let name = data.split(" ");
  const res =
    name.length >= 5
      ? name
          .map((item, key) => {
            return item.charAt(0).toUpperCase();
          })
          .join("")
      : data;
  return res == "HCPCIC" ? res.substring(0, res.length - 1) : res;
}

export function shortFileName(filename) {
  if (filename && filename.length > 35) {
    let fileExt = filename.split(".").pop();
    let nameWithoutExt = filename.replace(fileExt, "");
    let firstName = nameWithoutExt.slice(0, 28);
    let lastName = nameWithoutExt.slice(-3);
    return `${firstName}...${lastName}${fileExt}`;
  } else {
    return filename;
  }
}

export const insertStringScript = (id, str) => {
  var scriptTag = document.createElement("script");
  scriptTag.id = id;
  scriptTag.text = str;
  document.head.appendChild(scriptTag);
};

export const currencyFormatter = (Num) => {
  if (!Num) {
    return Num;
  } else {
    Num = Num.length > 20 ? Num.substring(0, 19) : Num;
    if (Num.length <= 20) {
      Num += "";
      Num = Num.replace(/,/g, "");
      let x = Num.split(".");
      let x1 = x[0];
      let x2 = x.length > 1 ? "." + x[1].substring(0, 2) : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + "," + "$2");

      return x1 + x2;
    } else return Num;
  }
};

export const currencyFormatterWithAddAmount = (amount) => {
  let result = "";
  if (amount === 0) {
    return result;
  }
  let Num = parseFloat(amount).toFixed(2);
  Num = Num.length > 20 ? Num.substring(0, 19) : Num;
  if (Num.length <= 20) {
    Num += "";
    Num = Num.replace(/,/g, "");
    let x = Num.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1].substring(0, 2) : "";
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + "," + "$2");

    return x1 + x2;
  } else return Num;
};

export const mergeArrayByKey = function (a, b, prop) {
  if (b?.length == 0) {
    return a;
  }
  var reduced = a.filter(
    (aitem) => !b?.find((bitem) => aitem[prop] === bitem[prop]),
  );
  return reduced.concat(b);
};

export const mobileAndTabletcheck = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
export const isTablet = function () {
  return document.documentElement.clientWidth < 1024;
};
export const isMobile = function () {
  return document.documentElement.clientWidth < 769;
};
export const isDesktop = function () {
  return !navigator.userAgent.includes("Mobile");
};
export const isPotrait = function () {
  if (
    document.documentElement.clientWidth < document.documentElement.clientHeight
  ) {
    return true;
  } else {
    return false;
  }
};
export const isIpad = function () {
  if (
    navigator.userAgent.includes("iPad") &&
    ((document.documentElement.clientWidth == 1024 &&
      document.documentElement.clientHeight == 1366) ||
      (document.documentElement.clientHeight == 1024 &&
        document.documentElement.clientWidth == 1366) ||
      (document.documentElement.clientWidth == 1024 &&
        document.documentElement.clientHeight == 768))
  ) {
    return true;
  } else {
    return false;
  }
};
export const hasClass = function (el, className) {
  if (el && el.classList) return el.classList.contains(className);
  return (
    el && !!el.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"))
  );
};

export const addClass = function (el, className) {
  if (el && el.classList) el.classList.add(className);
  else if (!hasClass(el, className)) el.className += " " + className;
};

export const removeClass = function (el, className) {
  if (!el) return;
  if (el.classList) el.classList.remove(className);
  else if (hasClass(el, className)) {
    var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
    el.className = el.className.replace(reg, " ");
  }
};

export const validatePhone = function (phone) {
  var regex = new RegExp(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/); //regular expression to check valid phone number
  return regex.test(phone.trim());
};

export const validateEmail = function (email) {
  var regex = new RegExp(/^\w+([\+\.-]?\w?)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/); //regular expression to check valid email addresses
  return regex.test(email.trim());
};

export const validateUrl = function (url) {
  var regex = new RegExp(
    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
  ); //regular expression to check valid web url's
  return regex.test(url.trim());
};

export const validateSpecialCharString = function (splchar) {
  var regex = new RegExp(/^[a-zA-Z0-9 ~`@#$%*)(_{}:;"\/\[\]',&.-]+$/); //regular expression to check valid phone number
  return regex.test(splchar.trim());
};

export const parseDateWithUSCheck = function (date) {
  const userLang = navigator.language || navigator.userLanguage;
  var cdate = moment(date);
  let parsedDate = "";
  if (userLang === "en-US") {
    parsedDate = date;
  } else {
    parsedDate = cdate.format("DD/MM/YYYY HH:mm:ss.SSS");
  }

  return parsedDate;
};

// export const GetOrganizationImageUrl = function(orgId, fileName, imageSize)
// {
//     return `{urlScheme}://{siteFileUrlRoot}/{OrganizationPartialPath}/{"i"}/{SizeHintInKnownFormat(imageSize)}/{orgId}/{fileName}`;
// }
export const getQueryParam = (name, isTopBarSearch) => {
  var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
    window.location.href,
  );
  if (!results) {
    return 0;
  }
  if (isTopBarSearch) {
    return results[1] || "";
  }
  return results[1] || 0;
};

export const fallbackCopyTextToClipboard = (text, callback) => {
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    if (successful) callback();
    var msg = successful ? "successful" : "unsuccessful";
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text, callback) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, callback);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {
      callback();
    },
    function (err) {
      console.error("Async: Could not copy text: ", err);
    },
  );
};

export const staticServerPathValue = (configKey) => {
  let rootUrl = process.env[configKey];
  let urlScheme = process.env.UrlScheme;
  return (path = `${urlScheme}://${rootUrl}`);
};

export const generateHiddenField = (configKey) => {
  let configValue = process.env[configKey];
  return `<input id=${name} name=${name} type="hidden" value=${configValue}>`;
};

export const getInputWidth = (inputEl, classNames) => {
  var tmp = document.createElement("span");
  tmp.className = classNames;
  tmp.innerHTML = inputEl.value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  document.body.appendChild(tmp);
  var theWidth = tmp.getBoundingClientRect().width;
  document.body.removeChild(tmp);
  return theWidth;
};

export const renderStaticImage = (fileName) => {
  const rootUrl = process.env.siteUrl;
  const urlScheme = process.env.UrlScheme;

  if (!rootUrl || rootUrl == "") {
    console.error(
      'Key ["StaticFileRootUrl"] is empty. key is mandatory for render content images anywhere in Site.',
    );
    throw 'Key ["StaticFileRootUrl"] is empty. key is mandatory for render content images anywhere in Site.';
  }

  const path = `${urlScheme}://${rootUrl}${fileName}?v=${process.env.AppVersion}`;
  return path;
};

export const renderScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const url = getScriptUrl(fileName);
    var script = document.createElement("script");
    script.setAttribute("data-id", fileName + ".js");
    script.setAttribute("src", url);
    script.setAttribute("type", "text/javascript");
    document.body.appendChild(script);

    script.onload = () => {
      resolve(fileName);
    };
    script.onerror = () => {
      script.remove();
      reject(new Error(`Failed to load script: ${url}`));
    };
  });
};

export const renderCSS = (fileName, sourceUrl) => {
  const url = sourceUrl || getCssUrl(fileName);
  var link = document.createElement("link");
  link.setAttribute("data-id", fileName + ".css");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = url;
  document.head.appendChild(link);
};

export const isNullOrEmpty = (str) => {
  if (str) return str === "";
  return true;
};

export const getScriptUrl = (contentPath) => {
  const isMinified = process.env.IsMinificationEnable;
  const scriptFolderName = process.env.ScriptFolder;
  const rootUrl = process.env.siteUrl;
  const urlScheme = process.env.UrlScheme;

  if (
    isNullOrEmpty(isMinified) ||
    isNullOrEmpty(scriptFolderName) ||
    isNullOrEmpty(rootUrl)
  ) {
    console.error(
      'One of the Key ["StaticFileRootUrl", "IsMinificationEnable", "ScriptFolder"] is empty. These keys are mandatory for render Scripts anywhere in Site.',
    );
    throw 'One of the Key ["StaticFileRootUrl", "IsMinificationEnable", "ScriptFolder"] is empty. These keys are mandatory for render Scripts anywhere in Site.';
  }

  let path = `${urlScheme}://${rootUrl}/js/${contentPath}.js?v=${process.env.AppVersion}`;

  // if (isMinified === "true") {
  //   path = `${urlScheme}://${rootUrl}/${scriptFolderName}-prod/${contentPath}.js?v=${process.env.AppVersion}`;
  // } else {
  //   path = `${urlScheme}://${rootUrl}/${scriptFolderName}-dev/${contentPath}.js?v=${process.env.AppVersion}`;
  // }
  return path;
};

export const getCssUrl = (contentPath) => {
  const isMinified = process.env.IsMinificationEnable;
  const cssFolderName = process.env.CSSFolder;
  const rootUrl = process.env.siteUrl;
  const urlScheme = process.env.UrlScheme;

  if (
    isNullOrEmpty(isMinified) ||
    isNullOrEmpty(cssFolderName) ||
    isNullOrEmpty(rootUrl)
  ) {
    console.error(
      'One of the Key ["StaticFileRootUrl", "IsMinificationEnable", "cssFolderName"] is empty. These keys are mandatory for render Scripts anywhere in Site.',
    );
    throw 'One of the Key ["StaticFileRootUrl", "IsMinificationEnable", "cssFolderName"] is empty. These keys are mandatory for render Scripts anywhere in Site.';
  }

  let path = `${urlScheme}://${rootUrl}/${cssFolderName}"/${contentPath}.css`;

  if (isMinified === "true") {
    path = `${urlScheme}://${rootUrl}/${cssFolderName}-min/${contentPath}.min.css?v=${process.env.AppVersion}`;
  } else {
    path = `${urlScheme}://${rootUrl}/${cssFolderName}/${contentPath}.css?v=${process.env.AppVersion}`;
  }
  return path;
};

export const isWriteOffEnable = () => {
  return (
    document.getElementById("writeOff") &&
    document.getElementById("writeOff").value.toLowerCase()
  );
};

export const showWriteOffNotification = function () {
  var writeOffNotificationCont = $("#writeOffNotification");
  var isEnable = isWriteOffEnable() || "false";
  if (isEnable == "true") {
    writeOffNotificationCont.stop(true, true);
    writeOffNotificationCont.effect("highlight", 2000);
  }
  return isEnable;
};

export const fetchPropertyTimezone = function (
  listOfTimeZone,
  propertyTimeZone,
) {
  let tZValue = listOfTimeZone.filter(
    (item) => item.DisplayText == propertyTimeZone,
  )[0];
  return tZValue.UniversalTimeZoneId;
};

export const fetchDateFormatByTimezone = function (
  date,
  checkTimezone,
  toUpdateTimeZone,
) {
  if (checkTimezone === toUpdateTimeZone) {
    return momentTz.utc(date);
  } else {
    let currenttimebytz = moment.tz(date, checkTimezone).format();
    return momentTz.utc(currenttimebytz).tz(toUpdateTimeZone);
  }
};

export const fetchTimezoneAbbreviation = function (displayValue, tzData) {
  var listDisplayValue = [
    "Central Time (CT)",
    "Eastern Time (ET)",
    "Mountain Time (MT)",
    "Pacific Time (PT)",
  ];
  if (listDisplayValue.includes(displayValue)) {
    let value = displayValue.split("(")[1].replace(")", "");
    return value;
  }
  if (Array.isArray(tzData)) {
    const matchedTz = tzData.find(
      (tz) => tz.mapped_time_zone === displayValue || tz.standard_time_zone === displayValue
    );
    if (matchedTz?.display_value && matchedTz.display_value !== displayValue) {
      return fetchTimezoneAbbreviation(matchedTz.display_value, tzData);
    }
  }
  return displayValue;
};

export const checkAndShowDateFieldValueAccToWorkkardTz = function (
  date,
  dateFieldsLabel,
  dateFieldLabel,
  userTimezone,
  workkardTimezone,
  listOfTimeZone,
  format,
) {
  let value = "";
  if (dateFieldsLabel.includes(dateFieldLabel)) {
    let result = listOfTimeZone.filter(
      (item) => item.UniversalTimeZoneId == workkardTimezone,
    )[0];
    let timezoneAbbr = fetchTimezoneAbbreviation(result.DisplayText);
    value = `(${moment(date).format(format)} ${timezoneAbbr})`;
    return value;
  }
  return value;
};

export const singularize = (word) => {
  const endings = {
    ves: "fe",
    ies: "y",
    i: "us",
    zes: "",
    ses: "",
    es: "",
    s: "",
  };
  return word.replace(
    new RegExp(`(${Object.keys(endings).join("|")})$`),
    (r) => endings[r],
  );
};

export const getNavItem = (nav, oldName, casing, singular, item = "Name") => {
  let name =
    !isEmpty(nav) && nav[oldName] != undefined && nav[oldName].Status
      ? nav[oldName][item]
      : oldName;
  switch (casing) {
    case 0:
      name = name.toLowerCase();
      break;
    case 1:
      name = name.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
      );
      break;
    case 2:
      name = name.toUpperCase();
      break;
  }
  if (singular) name = singularize(name);
  return name;
};

export const getNavOldStatus = (nav, oldName) => {
  return !isEmpty(nav) ? nav[oldName]?.OldStatus : true;
};

export const isInValidDate = (date) => {
  let minDate = moment(new Date(1970, 0, 1), DATE_FORMAT);
  let inputDate = moment(date, DATE_FORMAT);
  return inputDate.isBefore(minDate);
};

export const convertToTitleCase = (str) => {
  str = str.toLowerCase();
  return str.replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
};

export const uploadFileOnPublicApi = async (formData) => {
  let oapi = process.env.core_gateway_url + publicApiConst.oapi;
  let org_id = $("#_co").val();
  let orgHeader = `org${process.env.header_seperator}id`;
  var options = {
    method: AppConstants.httpMethod.POST,
    url: `${oapi}${publicApiConst.api_file_upload}`,
    headers: {
      [orgHeader]: org_id,
    },
    data: formData,
  };

  return publicApiCall(options);
};

export const uploadFileOnPublicApiV2 = async (formData, moduleType) => {
  const moduleQuery = moduleType ? `?module=${moduleType}` : '';
  const apiPath = `${publicApiConst.api_file_upload_v2 }${moduleQuery}`;  
  const base = String(process.env.core_gateway_url || '').replace(/\/+$/, '');
  const path = String(apiPath || '').replace(/^\/+/, '');
  const url = `${base}/${path}`;
  const org_id = getOrgIdFromEnv() || (typeof $ === 'function' ? $("#_co").val() : '') || '';
  const orgHeader = `org-id`;
  var options = {
    method: AppConstants.httpMethod.POST,
    url,
    headers: {
      [orgHeader]: org_id,
    },
    data: formData,
  };
  return publicApiCall(options);
};

export const GetNoteTemplateIdsByShortName = (noteTemplates, shortname) => {
  if (noteTemplates != null && shortname != null) {
    return Array.from(
      new Set(
        noteTemplates
          .filter((x) => shortname.includes(x.TemplateShortName))
          .map((x) => x.Id),
      ),
    );
  }
};

export const DigestNoteFilters = (data, defaultData) => {
  let NotesFilter = {};
  if (defaultData) {
    NotesFilter[0] = defaultData && defaultData.deselected_note_template_ids;
  }
  data && data.forEach((element) => {
    NotesFilter[element.activity_template_id] =
      element?.deselected_note_template_ids || [];
  });
  return NotesFilter;
};

export const getUniqueTemplates = (
  templateObj,
  selectedTemplates,
  filterarr,
) => {
  if (selectedTemplates) {
    Object.keys(templateObj).forEach((data) => {
      if (selectedTemplates.includes(data)) {
        filterarr = filterarr.concat(templateObj[data]);
      }
    });
  }
  return filterarr;
};

export const publicApiCall = async (axiosConfig) => {
  //try {
  let access_token = await getAccessToken();
  if (access_token) {
    const isFormData = typeof FormData !== "undefined" && axiosConfig.data instanceof FormData;
    const baseHeaders = Object.assign({}, axiosConfig.headers, {
      Authorization: `Bearer ${access_token}`,
    });
    if (!isFormData) {
      baseHeaders["content-type"] = "application/json";
    }
    axiosConfig.headers = baseHeaders;
    let response = await axios(axiosConfig);
    return { data: response.data, status: 200, statusText: "OK" };
  } else {
    return {
      status: 400,
      statusText: "Error occured",
      toastPayload: showErrorToast(),
    };
  }
  // } catch (error) {
  //     return { status: 400, statusText: 'Error occured', toastPayload: showErrorToast() };
  // }
};

const getAccessToken = async () => {
  let auToken = await getToken();
  if (typeof auToken === "string" && auToken && !auToken.trim().startsWith("{")) {
    return auToken;
  }
  let tokenObj =
    auToken && (typeof auToken === "string" ? safeJsonParse(auToken) : auToken);
  if (tokenObj && tokenObj.access_token) return tokenObj.access_token;
  try {
    const fromAuthManager = getAuthToken();
    if (fromAuthManager) return fromAuthManager;
  } catch (e) { /* noop */ }
  return "";
};

function safeJsonParse(s) {
  try { return JSON.parse(s); } catch (e) { return null; }
}

const getToken = async () => {
  let auToken = getAUTokenFromCookie();
  return auToken
  // let data = {
  //   au_token: auToken,
  // };
  // var options = {
  //   method: AppConstants.httpMethod.POST,
  //   url: process.env.core_gateway_url + publicApiConst.auth,
  //   headers: {
  //     "content-type": "application/json",
  //   },
  //   data: data,
  // };

  // let res = await axios(options);

  // if (res.status != 200) {
  //   return null;
  // }

  // if (res.status === 200 && res.data.new_token == true) {
  //   let domainName = $("#siteUrl").val();
  //   Cookies.set("_au", res.data.result, { domain: domainName });
  // }
  // return res.data.result;
};

const extractAccessTokenFromRaw = (raw) => {
    if (!raw || typeof raw !== 'string') return raw;
    const trimmed = raw.trim();
    if (!trimmed.startsWith('{')) return trimmed;
    try {
        const parsed = JSON.parse(trimmed);
        return parsed.access_token || trimmed;
    } catch (e) {
        return trimmed;
    }
};

const getAUTokenFromCookie = () => {
    let _au;

    try {
        const fromCookie = Cookies.get('_au');
        if (fromCookie) {
            return extractAccessTokenFromRaw(fromCookie);
        }
    } catch (e) { /*  */ }

    if (window.location.href.includes('localhost')) {
        _au = getLocalhostAu();
    }
    else {
        const el = document.getElementById('_au');
        _au = el ? el.value : '';
    }

    return extractAccessTokenFromRaw(_au);
}

const showErrorToast = () => {
  const toastPayload = {
    message: "Something went wrong.",
    type: "warning",
    entityType: "publicapi",
    delayTime: 5000,
    showActions: false,
    autoClose: true,
    isCloseIcon: false,
    iconType: "warning",
  };
  return toastPayload;
};

export const getAxiosError =(error)=> {
  if(error?.response?.status == "401"){
      window.location.href = PATHS.LOGOUT;
  } else if (error?.response?.status == "400") {
      let  response = error.response;
      if(response.data.hasOwnProperty("fields")){
          response.data.fields.map((item) => {
                      $('#' + item.fieldName + 'errorBlock').text(item.errorMsg);
          });
          return {status:response.data?.status , error: response.data?.fields[0].errorMsg };
      } else {
        return  {status:response.data?.status , error: response.data?.message };
      }
  }
};

export const convertDateTimeToISOString = (datetime) => {
  if (datetime) {
    let idate = moment(datetime, DEFAULT_TIME_FORMAT);
    const toISOString = (date) => {
      const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");
      return (
        date._d.getFullYear() +
        "-" +
        pad(date._d.getMonth() + 1) +
        "-" +
        pad(date._d.getDate()) +
        "T" +
        pad(date._d.getHours()) +
        ":" +
        pad(date._d.getMinutes()) +
        ":" +
        pad(date._d.getSeconds())
      );
    };
    return toISOString(idate);
  }
  return "";
};

// Timezone values reaching these formatters come from several sources (activity
// due dates, custom fields, session context) and are not guaranteed to be IANA
// ids: some endpoints return a display label such as "Eastern Time (ET)" or a
// Windows id. Intl.DateTimeFormat only accepts IANA ids and throws a RangeError
// for anything else, which is fatal when the formatter runs inside a reducer, so
// every zone is validated here first.
const timeZoneValidity = new Map();

export const isValidTimeZone = (timeZone) => {
  if (!timeZone || typeof timeZone !== "string") return false;
  if (timeZoneValidity.has(timeZone)) return timeZoneValidity.get(timeZone);
  let valid = true;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone });
  } catch (e) {
    valid = false;
  }
  timeZoneValidity.set(timeZone, valid);
  return valid;
};

export const resolveTimeZone = (timeZone, fallback) => {
  if (isValidTimeZone(timeZone)) return timeZone;
  if (isValidTimeZone(fallback)) return fallback;
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Reverse lookup over the session timezone list: display label or Windows id
// -> IANA id. Memoized on the tzData array reference since it is stable for the
// lifetime of the session context.
const timeZoneAliasCache = new WeakMap();

export const buildTimeZoneAliasMap = (tzData) => {
  if (!Array.isArray(tzData) || tzData.length === 0) return {};
  if (timeZoneAliasCache.has(tzData)) return timeZoneAliasCache.get(tzData);
  const aliases = tzData.reduce((acc, tz) => {
    const iana = tz?.standard_time_zone;
    if (!iana) return acc;
    if (tz.display_value) acc[tz.display_value] = iana;
    if (tz.mapped_time_zone) acc[tz.mapped_time_zone] = iana;
    return acc;
  }, {});
  timeZoneAliasCache.set(tzData, aliases);
  return aliases;
};

export const toIanaTimeZone = (value, tzData) => {
  if (!value || typeof value !== "string") return value;
  if (isValidTimeZone(value)) return value;
  return buildTimeZoneAliasMap(tzData)[value] || value;
};

// Rewrites due_date_tz on an activity listing payload to an IANA id so every
// downstream consumer (listing, detail, edit form) sees the same format.
export const normalizeActivityTimeZones = (activities, tzData) => {
  if (!Array.isArray(activities)) return activities;
  return activities.map((item) => {
    if (!item?.due_date_tz) return item;
    const due_date_tz = toIanaTimeZone(item.due_date_tz, tzData);
    return due_date_tz === item.due_date_tz ? item : { ...item, due_date_tz };
  });
};

export const formatEpochWithTimezone = (epoch, timeZone, locale = 'en-US') => {
  if (epoch == null)
    return null
  // If the timestamp is in seconds, convert it to milliseconds
  const isSeconds = epoch?.toString().length <= 10;
  const msTimestamp = isSeconds ? epoch * 1000 : epoch;

  const dateObject = new Date(msTimestamp);

  // Configuration for only the Date string
  const dateOptions = {
    timeZone: resolveTimeZone(timeZone),
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Configuration for the full DateTime string
  const dateTimeOptions = {
    ...dateOptions,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };

  return {
    dateString: new Intl.DateTimeFormat(locale, dateOptions).format(dateObject),
    dateTimeString: new Intl.DateTimeFormat(locale, dateTimeOptions).format(dateObject),
  };
};

export const formatEpochDateTime = (epoch, timeZone) => {
  if (epoch == 0) return null;
  // Support both seconds and milliseconds
  const timestamp = epoch.toString().length === 10 ? epoch * 1000 : epoch;

  const date = new Date(timestamp);

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: resolveTimeZone(timeZone),
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return `${values.month}/${values.day}/${values.year} at ${values.hour}:${values.minute} ${values.dayPeriod}`;
};

export const formatEpochAsShortDateTime = (epoch, timeZone) => {
  if (epoch == null) return null;
  const isSeconds = epoch?.toString().length <= 10;
  const msTimestamp = isSeconds ? epoch * 1000 : epoch;
  const date = new Date(msTimestamp);

  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: resolveTimeZone(timeZone),
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  return formatted.replace(/\s?(AM|PM)$/i, (match) => match.toLowerCase());
};

export const toEpoch = (isoString) => {
    if (!isoString) return null;
    const ts = new Date(isoString).getTime();
    return isNaN(ts) ? null : ts;
};

export const fetchPreview = (guid) => {
    return axios.get(`${process.env.core_gateway_url}/1.0/preview`, {
        headers: getAuthHeaders(),
        params: { guid },
        responseType: 'blob',
    });
};

export const getImagePreview = (guid, onLoad, onError) => {
    let objectUrl = null;
    let cancelled = false;

    fetchPreview(guid)
        .then((response) => {
            if (cancelled) return;
            objectUrl = window.URL.createObjectURL(response.data);
            onLoad?.(objectUrl);
        })
        .catch((error) => {
            if (cancelled) return;
            onError?.(error);
        });

    return () => {
        cancelled = true;
        if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
};

export const fetchDownload = (guid) => {
    return axios.get(`${process.env.core_gateway_url}/1.0/download`, {
        headers: getAuthHeaders(),
        params: { guid },
        responseType: 'blob',
    });
};

export const triggerBlobDownload = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const downloadFile = async (guid, fileName) => {
    const response = await fetchDownload(guid);
    triggerBlobDownload(new Blob([response.data]), fileName);
};

export const hasGuidValue = (url) => {
    if (!url) return false;
    // Bare value (e.g. "<guid>.png" right after upload) is the guid itself
    const guid = /^https?:\/\//i.test(url) ? new URL(url).searchParams.get("guid") : url;
    return Boolean(guid) && guid !== "user.png";
};

const BYTES_PER_KB = 1024;
const HAS_UNIT_REGEX = /^\d+(?:\.\d+)?\s*[a-z]+$/i;
export const formatSizeInKB = (value, { fallback = "0 KB" } = {}) => {
  if (value == null || String(value).trim() === "") return fallback;

  // Already has a unit -> leave as is
  if (typeof value === "string" && HAS_UNIT_REGEX.test(value.trim())) {
      return value.trim();
  }

  // No unit -> treat as bytes and convert to KB
  const bytes = Number(value);
  if (!Number.isFinite(bytes) || bytes < 0) return fallback;

  return `${Math.round(bytes / BYTES_PER_KB)} KB`;
};

// Converts a snake_case / lowercase string to PascalCase.
// toPascalCase("state_full_name") -> "StateFullName"
// toPascalCase("city")            -> "City"
export const toPascalCase = (key) =>
    String(key)
        .split("_")
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("");

const isPlainObject = (value) =>
    value !== null && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date);

// Recursively converts all object keys to PascalCase.
// Works on arrays, single objects, and nested structures.
// Non-object values (strings, numbers, null, Dates) are returned unchanged.
export const pascalCaseKeys = (data) => {
    if (Array.isArray(data)) return data.map(pascalCaseKeys);

    if (isPlainObject(data)) {
        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => [toPascalCase(key), pascalCaseKeys(value)])
        );
    }

    return data;
};

const PROFILE_RETURN_KEY = 'profileReturnUrl';

// Remembers the current hash, then opens the profile hash
export function openProfileHash() {
    if (window.location.hash !== '#profile') {
        sessionStorage.setItem(PROFILE_RETURN_KEY, JSON.stringify({
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        }));
    }
    window.location.hash = '#profile';
}

// While Manage Profile is open, a tab changing only the hash records it as the hash to return to
function deferHashWhileProfileOpen(path) {
    if (window.location.hash !== '#profile' || !path || path.hash === undefined) return false;
    const { pathname, search } = window.location;
    if ((path.pathname ?? pathname) !== pathname || (path.search ?? search) !== search) return false;
    const hash = path.hash ? (path.hash.startsWith('#') ? path.hash : `#${path.hash}`) : '';
    if (hash === '#profile') return false;
    sessionStorage.setItem(PROFILE_RETURN_KEY, JSON.stringify({ pathname, search, hash }));
    return true;
}

// Replaces "#profile" with the hash that was there before Manage Profile was opened
export function clearProfileHash(history) {
    if (window.location.hash !== '#profile') return;
    const saved = JSON.parse(sessionStorage.getItem(PROFILE_RETURN_KEY) || 'null');
    sessionStorage.removeItem(PROFILE_RETURN_KEY);
    const { pathname, search } = window.location;
    const hash = saved?.pathname === pathname && saved.search === search ? saved.hash : '';
    history.replace({ pathname, search, hash });
}

// Make string to camelCase
export const toCamelCase = (str) => {
    const text = String(str ?? "").trim();
    if (!text) return "";

    const parenIndex = text.indexOf("(");
    const main = parenIndex === -1 ? text : text.slice(0, parenIndex);
    const suffix = parenIndex === -1 ? "" : text.slice(parenIndex);

    const formattedMain = main
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");

    return [formattedMain, suffix].filter(Boolean).join(" ");
};
// Profile image URLs are served as `...?guid=<file name>`, while live events
// carry only the bare file name. These read and swap that file name so a URL
// can be rebuilt from an event without the client knowing the URL format.
export const imageGuid = (url) => {
    try {
        return new URL(url).searchParams.get('guid');
    } catch (e) {
        return null;
    }
};

export const withImageGuid = (url, guid) => {
    try {
        const next = new URL(url);
        next.searchParams.set('guid', guid);
        return next.toString();
    } catch (e) {
        return null;
    }
};
